// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d70b3f1d","455":"08c7a3e1","644":"e3367587","977":"7876933e"}[chunkId] + ".chunk.js";
};